import React from 'react';
import { arrowLeft, ArrowRight, arrowRight } from 'res/images';
import { scrollToTop } from './Helper';
import './pagination.scss';

const Pagination = (props) => {
  const { totalPages, currentPage, setCurrentPage, data, length, seterror, dashboard, scroll, page } = props;

  const pagesList = () => {
    let arr = new Array();
    arr.length = totalPages;
    arr.fill(0);
    return arr.map((item, index) => {
      const page = index + 1;
      if (page > currentPage - 5 && page < currentPage + 5) {
        return (
          <div
            className={`pageDiv ${currentPage == page ? 'activePage' : ''}`}
            key={index}
            onClick={() => {
              setCurrentPage(page);
              // seterror(false);
            }}
            style={{fontSize:'0.85rem'}}
          >
            {page}
          </div>
        );
      } else {
        return;
      }
    });
  };

  const renderPages = () => {
    return (
      <div className={`d-flex justify-content-between align-items-center w-100 ${!dashboard ? 'paginationPart' : ''}`}>
        <div className='totalResult patientPerPage' style={{ fontSize: '0.87rem' }}>
          {length ? (
            <div>
              Total Result:
              <span>{length}</span>
            </div>
          ) : null}
          {page === "patient" && <div style={{marginLeft: "40px",fontSize:'0.87rem'}}><b>20</b> Patients per page</div>}
        </div>
        {totalPages > 1 ? (
          <div onClick={!scroll && scrollToTop} className='paginationDiv' style={{ fontSize: '0.75rem', fontWeight: '600' }}>
            {currentPage != 1 && (
              <div className='pageDiv' onClick={() => setCurrentPage(currentPage - 1)}>
                <img src={arrowLeft} style={{ height: '14px', width: '14px' }} />
              </div>
            )}
            {pagesList()}
            {totalPages > currentPage && (
              <div className='pageDiv' onClick={() => setCurrentPage(currentPage + 1)}>
                <img src={ArrowRight} style={{ height: '14px', width: '13px' }} />
              </div>
            )}
          </div>
        ) : null}
      </div>
    );
  };
  return renderPages();
};

export default Pagination;
